import { useMutation, useQueryClient } from '@tanstack/react-query'

import { dataOrThrow, type PostPetBody } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'
import { meQueryKey } from '@/customer/hooks/use-get-me'
import { captureEvent } from '@/customer/lib/posthog'

/**
 * Creates a patient owned by the signed-in member via
 * `POST /api/portal/pets`. Invalidates the `me` snapshot on success so
 * the new patient appears in downstream reads without a manual refetch.
 */
export function useCreatePet() {
  const api = usePortalApi()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body: PostPetBody) => dataOrThrow(await api.post('/pets', { body })),
    onSuccess: ({ patient }) => {
      queryClient.invalidateQueries({ queryKey: meQueryKey })
      captureEvent('pet_added', { patient_id: patient.id, species: patient.species })
    },
  })
}
